<svg width="54" height="54" class="settings-tile-svg-stroke tile__svg-stroke">
    <circle cx="27" cy="27" r="26" class="settings-tile-svg-stroke tile__svg-stroke"
            stroke-width="2" stroke-opacity="0.2" fill="none">
    </circle>
    <path class="settings-tile-svg-fill tile__svg-fill"
          [attr.d]="circlePath" stroke="none">
    </path>
</svg>
